import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { TbRoute } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { HotelClinicNames } from "@/models/hotel-clinic.model";

import { HotelClinicListItem, HotelClinicResolvedPassenger } from "../../types";
import ClinicArrivalRouteCell from "./ClinicArrivalRouteCell";

type ClinicArrivalRouteRow = Pick<HotelClinicListItem | HotelClinicResolvedPassenger, "hotel" | "clinic" | "cancelled">;

export const ClinicArrivalRouteColumn = ({ t }: { t: TFunction }): GridColDef<ClinicArrivalRouteRow> => {
    return {
        field: "route",
        headerName: t("route"),
        minWidth: 220,
        flex: 0.5,
        filterable: false,
        sortable: false,
        valueGetter: (_val, row) => `${row.hotel}-${row.clinic}`,
        renderHeader: (params) => <TableHeader Component={TbRoute} title={params.colDef.headerName!} />,
        renderCell: ({ row }) => (
            <ClinicArrivalRouteCell
                hotel={row.hotel}
                clinic={row.clinic as HotelClinicNames}
                isCancelled={row.cancelled}
            />
        ),
    };
};

export default ClinicArrivalRouteColumn;
